"use strict";
// Filters namespace converted to module
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationTypeIterable = exports.CompareOperatorIterable = exports.EqualOperatorIterable = exports.InListConfigIterable = exports.OrderByOperatorIterable = void 0;
exports.OrderByOperatorIterable = ['asc', 'desc'];
exports.InListConfigIterable = ['inList', 'notInList'];
exports.EqualOperatorIterable = ['equals', 'notEqual'];
exports.CompareOperatorIterable = [
    'lessThan',
    'greaterThan',
    'greaterThanOrEqual',
    'lessThanOrEqual',
];
exports.OperationTypeIterable = [
    'orderBy',
    'orderBySum',
    'notEqual',
    'equals',
    'lessThan',
    'greaterThan',
    'greaterThanOrEqual',
    'lessThanOrEqual',
    'inList',
    'notInList',
];
//# sourceMappingURL=Filters.js.map